import AddProductsUsingFiltersModal from "../../../../../../../modals/AddProductsUsingFiltersModal/AddProductsUsingFiltersModal.js";
import { FC, useCallback, useEffect, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import PreviewSelectSection from "./components/PreviewSelectSection/PreviewSelectSection.js";
import SectionWithTable from "./components/SectionWithTable/SectionWithTable.js";
import { removeDuplicateObjects } from "../../../../../../../../../helpers/removeDuplicateObjects.js";

interface SelectedProductsFieldProps extends FieldRenderProps<any> {
}

const prepareSelectedProducts = (selecteProducts) => {
  return selecteProducts.map(item => ({
    id: item.id,
    type: "product",
    title: item.title,
    totalInventory: item.totalInventory,
    tracksInventory: item.tracksInventory,
    images: item.images
  }))
}

const prepareSelectedCollections = (selecteProducts) => {
  return selecteProducts.map(item => ({
    id: item.id,
    handle: item.handle,
    type: "collection",
    title: item.title,
    productsCount: item.productsCount,
    image: item.image
  }))
}

const SpecificSelectionSection: FC<SelectedProductsFieldProps> = ({ input, values, setFilterValues, filterValues, totalFetched, setTotalFetched, totalCount, setTotalCount, setIsProductUsed }) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    setIsProductUsed(true)
    if (!values.selectedSpecificItems.length && Object.keys(filterValues).length > 0) {
      setFilterValues({})
    }
  }, [setFilterValues, values.selectedSpecificItems])

  const handleAddProducts = useCallback((selectPayload) => {
    const uniqueArray = removeDuplicateObjects([...values.selectedSpecificItems, ...prepareSelectedProducts(selectPayload.selection)], 'id');
    if (Object.keys(filterValues).length > 0) {
      const manuallyAddedProducts = uniqueArray.length - values.selectedSpecificItems.length
      setTotalCount(prev => prev + manuallyAddedProducts)
    }
    input.onChange(uniqueArray);
  }, [values, input]);

  const handleRemoveProducts = useCallback((selectPayload) => {
    input.onChange([])
    setTotalFetched(0);
    setTotalCount(0)
  }, [values, input]);

  const handleAddCollections = useCallback((selectPayload) => {
    const preparedCollections = prepareSelectedCollections(selectPayload.selection);
    const uniqueArray = removeDuplicateObjects([...values.selectedSpecificItems, ...preparedCollections], 'id');

    if (uniqueArray.length > values.selectedSpecificItems.length && Object.keys(filterValues).length > 0) {
      const manuallyAddedProductsCount = preparedCollections.reduce((acc, collection) => acc + collection.productsCount, 0);
      setTotalCount(prev => prev + manuallyAddedProductsCount);
    }

    input.onChange(uniqueArray);
  }, [values, input, totalCount]);

  const handleDelete = useCallback((id) => {
    const updatedArray = [];
    let itemToDelete = null;

    for (const item of values.selectedSpecificItems) {
      if (item.id === id) {
        itemToDelete = item;
      } else {
        updatedArray.push(item);
      }
    }

    input.onChange(updatedArray);

    if (itemToDelete && Object.keys(filterValues).length > 0) {
      if (itemToDelete.id.includes("Collection")) {
        setTotalCount(prev => prev - itemToDelete.productsCount);
      } else {
        setTotalCount(prev => prev - 1);
      }
    }
  }, [values, input, filterValues]);

  const handleFilterSubmit = useCallback((submittedValues) => {
    setTotalFetched(0);
    setFilterValues(submittedValues);
  }, []);

  return (
    <>
      {
        values.selectedSpecificItems.length ?
          <SectionWithTable
            handleDelete={handleDelete}
            values={values}
            totalCount={totalCount}
            filterValues={filterValues}
            handleAddProducts={handleAddProducts}
            handleAddCollections={handleAddCollections}
            initialSelectionIds={input.value}
            input={input}
            totalFetched={totalFetched}
            setTotalFetched={setTotalFetched}
            setPage={setPage}
            page={page}
            handleRemoveProducts={handleRemoveProducts}
          /> :
          <PreviewSelectSection
            handleAddProducts={handleAddProducts}
            handleAddCollections={handleAddCollections}
            initialSelectionIds={input.value}
          />
      }
      <AddProductsUsingFiltersModal setTotalFetched={setTotalFetched} input={input} onSubmit={handleFilterSubmit} setTotalCount={setTotalCount} setPage={setPage} />
    </>
  );
};

export default SpecificSelectionSection;
